import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import colors from "/styles/colors";
import { THUMBNAILS_TYPES } from "/constants/thumbnails-types";
import DirectoryEmptyStateComponent from "../directory-empty-state/directory-empty-state-component";
import ThumbnailsListComponent from "/components/core/lists/thumbnails-list/thumbnails-list-component";
import SignupWithTextComponent from "/components/core/signups/signup-with-text/signup-with-text-component";
import { StyledDirectoryComponent } from "./directory-component.scss";
class DirectoryComponent extends PureComponent {
    emptyStateRenderer() {
        const { emptyStateRenderer } = this.props;
        return emptyStateRenderer ? emptyStateRenderer() : /*#__PURE__*/ _jsx(DirectoryEmptyStateComponent, {});
    }
    render() {
        const { tuhmbnailsListData, backgroundColor, thumbnailType, filterTerm, signupForm, filterValidator } = this.props;
        const listData = tuhmbnailsListData.map((item)=>item.props);
        const allowSignupForm = signupForm && signupForm.show;
        return /*#__PURE__*/ _jsxs(StyledDirectoryComponent, {
            className: "directory-component",
            style: {
                backgroundColor
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "directory-list-wrapper",
                    children: /*#__PURE__*/ _jsx(ThumbnailsListComponent, {
                        filterTerm: filterTerm,
                        tuhmbnailsListData: tuhmbnailsListData,
                        thumbnailType: thumbnailType,
                        emptyStateRenderer: this.emptyStateRenderer,
                        filterValidator: filterValidator
                    })
                }),
                allowSignupForm && /*#__PURE__*/ _jsx("div", {
                    className: "directory-signup-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupWithTextComponent, {
                        title: signupForm.title,
                        subtitle: signupForm.subtitle
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.emptyStateRenderer = this.emptyStateRenderer.bind(this);
    }
}
export { DirectoryComponent as default };
DirectoryComponent.defaultProps = {
    tuhmbnailsListData: [],
    thumbnailType: THUMBNAILS_TYPES.BACKGROUND_COLOR,
    backgroundColor: colors["light-grey"],
    signupForm: {
        show: true,
        title: "Start using monday.com today",
        subtitle: "Try it now for free / No credit card needed"
    }
};
